import dynamic from "next/dynamic";
import PropTypes from "prop-types";

import KvkkContent from "@/modal-contents/kvkk-contents";
import ModalTextContent from "components/modal-text-content";

const Modal = dynamic(() => import("components/common/modal"), { ssr: false });

const PPLModal = ({ isOpen, handleClose }) => (
  <Modal isOpen={isOpen} handleClose={handleClose}>
    <ModalTextContent>
      <KvkkContent />
    </ModalTextContent>
  </Modal>
);

PPLModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default PPLModal;
